import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { getSettingsTabs } from './settings.config';
import styles from './SettingsLayout.module.css';
export function SettingsLayout() {
    const { t } = useTranslation();
    const tabs = getSettingsTabs(t);
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("nav", { className: styles.navigation, "aria-label": t('settings.navigation-label'), children: tabs.map(item => (_jsx(NavLink, { to: item.route, end: item.exactMatch ?? true, className: ({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab), children: item.title }, item.route))) }), _jsx("div", { className: styles.content, children: _jsx(Outlet, {}) })] }));
}
export default SettingsLayout;
